<template>
  <div class="m-ai-message">
    <el-avatar shape="square" icon="el-icon-user" :src="info.avatar"></el-avatar>
    <div :class="info">
      <div class="user">
        <p style="font-size: 12px; color: #000;width: auto" v-if="info.msgType !== 6">
          <span>{{ info.company }}</span>
        </p>
        <p style="font-size: 12px; color: #999;width: auto">
          <span>{{ info.name }}</span>
        </p>
      </div>
      <div class="bubble ai-bubble">
        <div class="pre-box">
          <span v-for="item in info.ats" :key="item.at" type="text" class="at-btn" @click.stop="link('user', { id: item.at })">@{{ item.atName }} </span>
          <pre>{{ info.txt }}</pre>
          <div
            class="company-card"
            v-if="aiResult"
            @click="
              link('company', {
                id: aiResult.companyId,
                name: aiResult.companyName
              })
            "
          >
            <p class="company-name">{{ aiResult.companyName }}</p>
            <div class="tags-box">
              <span v-if="aiResult.memberLevel" style="background: #FB5E5E;border-color: #EE2929;"> 会员级别 {{ aiResult.memberLevel }} </span>
              <span style="background: #00A2F3;border-color: #2288CC;" v-if="aiResult.isPromoteMall">商城</span>
              <span v-if="aiResult.businessYears" style="background: #1BB934;border-color: #0F9321;">{{ aiResult.businessYears }}</span>
            </div>
            <!--            <p>-->
            <!--              <span class="title">持续经营年限</span>-->
            <!--              <span>{{ aiResult.businessYears }}</span>-->
            <!--            </p>-->
            <!--            <p>-->
            <!--              <span class="title">员工人数</span>-->
            <!--              <span>{{ aiResult.employeesCount }}</span>-->
            <!--              <span v-if="aiResult.employeesCount" class="promise">{{-->
            <!--                aiResult.isPromise ? "(已核实)" : "(未核实)"-->
            <!--              }}</span>-->
            <!--            </p>-->
            <!--            <p>-->
            <!--              <span class="title">办公+仓库面积</span>-->
            <!--              <span>{{ aiResult.officeArea }}</span>-->
            <!--              <span v-if="aiResult.officeArea" class="promise">{{-->
            <!--                aiResult.isPromise ? "(已核实)" : "(未核实)"-->
            <!--              }}</span>-->
            <!--            </p>-->

            <div class="concat-box">
              <div>
                <span class="label">电话: </span>
                <div class="tel-box" v-if="aiResult.contacts.length">
                  <div v-for="(item, index) in aiResult.contacts" :key="index">
                    <span class="number">{{ item.number }} </span>
                    <span class="name">{{ item.contact }}</span>
                  </div>
                </div>
                <div v-else>--</div>
              </div>
              <div>
                <span class="label">QQ: </span>
                <div class="qq-box" v-if="aiResult.qq.length">
                  <div v-for="(item, index) in aiResult.qq" :key="index">
                    {{ item }}
                  </div>
                </div>
                <div v-else>--</div>
              </div>
              <div>
                <span class="label">地址: </span>
                <div class="address">{{ aiResult.address || "--" }}</div>
              </div>
            </div>
            <div class="labels-box">
              <h3>客户给TA贴的标签 <span>(橙色为我给TA贴的)</span></h3>
              <template v-if="aiResult.labels.length || aiResult.otherLabels.length">
                <div class="green-tags">
                  <span class="tag" v-for="(item, index) in aiResult.labels" :key="index">{{ item.label }}({{ item.qty }})</span>
                </div>
                <div class="orange-tags">
                  <span class="tag" v-for="(item, index) in aiResult.otherLabels" :key="index">{{ item.label }}({{ item.qty }})</span>
                </div>
              </template>
              <template v-else-if="aiResult.labels.length && aiResult.otherLabels.length">
                <span style="color: #b3b3b3; font-size: 12px;padding: 0">暂无标签</span>
              </template>
            </div>
            <p class="more">
              <span>点击查看更多>></span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    link(path, query) {
      if (window.getSelection().toString()) {
        return false;
      }
      if ((path === "detail" || path === "user") && !query.id) {
        return false;
      }
      this.$store.commit("setChatScroll");
      this.$router.push({
        path: `/${path}`,
        query
      });
    }
  },
  computed: {
    likeList() {
      return this.$store.state.likeList;
    },
    tipStyle() {
      if (this.info.reply) {
        return null;
      }
      const index = this.types.findIndex(item => item.label === this.info.tags);
      if (index !== -1) {
        return { background: this.types[index].color, cursor: "pointer" };
      }
      return null;
    },
    aiResult() {
      if (this.info.aiResult && this.info.aiResult.length) {
        const res = this.info.aiResult[0];
        const contacts = [];
        const qq = [];
        const labels = [];
        const otherLabels = [];
        res.Labels &&
          res.Labels.map(item => {
            const data = { label: item.Label, qty: item.Qty };
            item.IsMine ? otherLabels.push(data) : labels.push(data);
          });
        res.Contacts &&
          res.Contacts.map(item => {
            if (!item.Number) {
              return false;
            }
            if (item.NumberType === 3) {
              qq.push(item.Number);
            } else {
              contacts.push({
                number: item.Number,
                isDefault: item.IsDefault,
                contact: item.Contact
              });
            }
          });
        return {
          companyName: res.CompanyName,
          companyId: res.CompanyId,
          contacts,
          qq,
          labels,
          otherLabels,
          address: res.Address,
          isPromoteMall: res.IsPromoteMall,
          memberLevel: res.MemberLevel,
          businessYears: res.BusinessYears,
          dailyVisits: res.DailyVisits,
          employeesCount: res.EmployeesCount,
          officeArea: res.OfficeArea,
          isPromise: res.IsPromise
        };
      } else {
        return null;
      }
    }
  },
  props: {
    info: {}
  }
};
</script>
<style lang="scss">
.m-ai-message {
  display: flex;
  width: 100%;
  > div {
    display: flex;
    flex-direction: column;
  }

  .el-avatar {
    flex-shrink: 0;
    margin-right: 10px;
    cursor: pointer;
  }

  &.direction-left {
    .el-avatar {
      margin-right: 10px;
    }
  }

  .user {
    display: inline-block;
    color: #666;
    font-size: 12px;
    margin-bottom: 2px;

    span {
      cursor: pointer;
    }
  }

  .info {
    max-width: 80%;
    min-width: 45%;
  }
  .bubble {
    $bgColor: #fff3e0;
    position: relative;
    border-radius: 2px;
    box-shadow: 3px 3px 2px 0px rgba(0, 0, 0, 0.1);
    font-size: 14px;
    margin-bottom: 20px;
    background-color: $bgColor;
    &:after {
      position: absolute;
      left: -10px;
      top: 18px;
      display: block;
      content: "";
      width: 0;
      height: 0;
      border: 5px solid transparent;
      border-right-color: $bgColor;
    }

    .btn {
      position: absolute;
      right: 20px;
      text-decoration: underline;
    }

    .txt {
      display: block;
      width: 100%;
      padding: 5px 40px 5px 10px;
      background-color: #eee;
      border-radius: 4px;
    }
  }

  .pre-box {
    padding: 10px;
    display: block;

    .el-button {
      padding: 0;
      margin: 0;
      margin-right: 5px;
    }
  }
  .company-card {
    margin-top: 10px;
    display: flex;
    cursor: pointer;
    min-width: 270px;
    flex-direction: column;
    padding: 8px 8px 8px 12px;
    justify-content: center;
    background-color: #fff9f0;
    .company-name {
      font-weight: bold;
      color: #000;
      font-size: 14px;
      margin-bottom: 5px;
      text-align: center;
    }
    .more {
      margin-top: 8px;
      text-align: center;
      span {
        color: #2288cc;
      }
    }
    .tags-box {
      display: flex;
      justify-content: center;
      span {
        margin-right: 4px;
        margin-bottom: 10px;
        border-radius: 2px;
        border: 1px solid transparent;
        padding: 1px 4px;
        color: #fff;
        font-size: 12px;
      }
    }
    .concat-box {
      color: #000;
      > div {
        display: flex;
        font-size: 12px;
        margin-bottom: 5px;
      }
      .label {
        width: 35px;
        white-space: nowrap;
        color: #999;
      }
    }
    .labels-box {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      span {
        display: inline-flex;
        padding: 1px 2px;
        border-radius: 2px;
        font-size: 12px;
        margin-right: 4px;
        margin-bottom: 4px;
        flex-wrap: nowrap;
        line-height: 12px;
      }
      h3 {
        font-size: 12px;
        color: #999;
        font-weight: normal;
        margin-bottom: 5px;
      }
      .green-tags {
        .tag {
          color: #0f9321;
          border: 1px solid #0f9321;
        }
      }
      .orange-tags {
        .tag {
          color: #ed6f00;
          border: 1px solid #ed6f00;
        }
      }
    }
    p {
      font-size: 12px;
      line-height: 20px;
      .title {
        color: #999999;
        display: inline-block;
        width: 100px;
      }
    }
  }
}
</style>
